import { DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

import { NotificationService } from "src/app/core/notification.service";
import { PicketService } from "src/app/core/picket.service";
import { ApiResponse } from "src/app/shared/interfaces/api-response";
import { MemberDetails } from "src/app/shared/interfaces/member-details";
import {
    PicketRecordDetails,
    SignedInOutMemberDetails,
} from "src/app/shared/interfaces/picket-member-details";

@Component({
  selector: "app-picket-sign-out",
  templateUrl: "./picket-sign-out.component.html",
  styleUrls: ["./picket-sign-out.component.css"],
})
export class PicketSignOutComponent implements OnInit {
  strikeId = "";
  picketId = "";
  picketName = "";
  currentTime: Date = new Date();
  filterMember = "";
  member: MemberDetails = { MemberId: "" };
  lastSignedOutMembers: SignedInOutMemberDetails[] = [];
  lastSignedOutMember: SignedInOutMemberDetails = { MemberId: "" };
  displayNotYetSignedMessage = false;
  notYetSignedMessage = "";
  existingSignIn: PicketRecordDetails = { MemberId: "" };
  missingSignIn: MemberDetails = { MemberId: "" };
  picketSignOut: PicketRecordDetails = { MemberId: "" };
  slNo = 0;

  constructor(
    private route: ActivatedRoute,
    private picket: PicketService,
    private notificationService: NotificationService,
    private datePipe: DatePipe,
  ) {}

  ngOnInit() {
    this.strikeId = String(this.route.snapshot.paramMap.get("id"));
    this.picketId = String(this.route.snapshot.paramMap.get("picket"));
    this.picketName = String(this.route.snapshot.paramMap.get("name"));
    this.getTime();
  }

  getTime() {
    setInterval(() => {
      this.currentTime = new Date();
    }, 1000);
  }

  async searchMbr() {
    const response = await this.picket.getPicketMemberInfo(
      this.strikeId,
      this.filterMember,
    );

    if (response.success) {
      this.searchMbrSuccess(response);
    } else {
      this.searchMbrFail(response);
    }
  }

  async searchMbrSuccess(response: ApiResponse) {
    this.member = response.body;

    // Uses ID rather than memberId
    const lastSignInResponse = await this.picket.getLatestSignIn(
      this.strikeId,
      String(this.member.ID),
    );

    if (lastSignInResponse.success) {
      this.loadSignInPicketSuccess(lastSignInResponse);
    } else {
      this.loadSignInPicketFail();
    }
  }

  searchMbrFail(response: ApiResponse) {
    this.member = { MemberId: "" };
    
    if (response.statusCode == 400) {
      this.notificationService.displayError(response.body);
    }
    else {
      this.notificationService.displayError(response.errorMessage);
    }
  }

  loadSignInPicketFail() {
    this.existingSignIn = { MemberId: "" };
    this.displayNotYetSignedMessage = true;

    this.notYetSignedMessage =
      this.member.MemberId +
      "  " +
      this.member.FirstName +
      "  " +
      this.member.MiddleName +
      "  " +
      this.member.LastName;
  }

  loadSignInPicketSuccess(response: ApiResponse) {
    this.existingSignIn = response.body;
    this.displayNotYetSignedMessage = false;
  }

  clearSearchMbr() {
    this.filterMember = "";
  }

  async addSignOutPicketline() {
    this.existingSignIn.SignOutTime = this.currentTime;
    this.existingSignIn.SignOutMethod = "ID Card Scanned";
    this.existingSignIn.SignOutLocalTime = String(this.datePipe.transform(this.currentTime, "MM/dd/yyyy HH:mm"));

    const response = await this.picket.addSignOut(this.existingSignIn);

    if (response.success) {
      this.addedSuccess(response);
    } else {
      this.addedFail(response);
    }
  }

  async addedSuccess(response: ApiResponse) {
    this.notificationService.displaySuccess("Sign-out recorded successfully");
    this.slNo += 1;
    
    this.lastSignedOutMember.FirstName = this.member.FirstName;
    this.lastSignedOutMember.Hours = response.body.Hours;
    this.lastSignedOutMember.LastName = this.member.LastName;
    this.lastSignedOutMember.MemberId = this.member.MemberId;
    this.lastSignedOutMember.MiddleName = this.member.MiddleName;
    this.lastSignedOutMember.Minutes = response.body.Minutes;
    this.lastSignedOutMember.SignIn = response.body.SignInTime;
    this.lastSignedOutMember.SignOut = response.body.SignOutTime;
    this.lastSignedOutMember.SlNo = this.slNo;

    this.lastSignedOutMembers.push(this.lastSignedOutMember);
    this.lastSignedOutMember = { MemberId: "" };
    this.existingSignIn = { MemberId: "" };
    this.member = { MemberId: "" };
    this.filterMember = "";
  }

  addedFail(response: ApiResponse) {
    this.notificationService.displayError(response.errorMessage);
  }
}
